const ROLE = {
  ADMIN: 'ADMIN',
  ISO: 'ISO',
  ISV_LEVEL_1: 'ISV_LEVEL_1',
  ISV_LEVEL_2: 'ISV_LEVEL_2',
  AGENT: 'AGENT'
};
export { ROLE }